import React from "react";
import { ResetGuardProps } from "./Guard.types";
import { useNavigation } from "@react-navigation/native";

export default function ResetGuard({ to }: ResetGuardProps) {
  const navigation = useNavigation();
  React.useEffect(() => {
    navigation.reset({ index: 0, routes: [{ name: to }] });
  }, []);
  return null;
}
